import style from './style.module.scss';

const Table = ({ children, className }) => {
  return <table className={`${style.table} ${className}`}>{children}</table>;
};

export default Table;
